import { AxiosResponse } from 'axios';
import { pluck } from 'ramda';

import { Method, checkStatuses } from './checkStatus';

export default <T extends Pick<AxiosResponse, 'status'>>(response: T[], method: Method = 'lt') =>
  checkStatuses(pluck('status', response), method);
